import type { ISchedule } from "@gettactic/api";
import { format, parseISO } from "date-fns";

export function getTimeFromSchedule(
  scheduleDateString: string,
  strFormat = "h:mm a"
): string {
  return format(parseISO(scheduleDateString.replace("Z", "")), strFormat);
}

export function getDateFromSchedule(
  scheduleDateString: string,
  strFormat = "yyyy-MM-dd"
): string {
  return format(parseISO(scheduleDateString.replace("Z", "")), strFormat);
}

export function getScheduleDateWithTime(scheduleDateString: string): string {
  return `${getDateFromSchedule(scheduleDateString)}T${getTimeFromSchedule(scheduleDateString, "HH:mm:ss")}`;
}

/**
 * A schedule's start–end time, formatted for display (e.g. "9:00 AM – 5:00 PM").
 * Falls back to just the start time when the schedule has no end.
 */
export function formatScheduleTimeRange(schedule: ISchedule): string {
  const start = getTimeFromSchedule(schedule.start);
  if (!schedule.end) {
    return start;
  }
  return `${start} – ${getTimeFromSchedule(schedule.end)}`;
}
